/**
 * Event Scroll Toast (Mobile)
 */

export function initScrollToast(): void {
  const scrollToast = document.querySelector<HTMLElement>('[data-scroll-toast]');
  let scrollToastShown = sessionStorage.getItem('scrollToastShown');

  if (!scrollToast || scrollToastShown || window.innerWidth >= 1024) return;

  const scrollThreshold = 0.6;

  function checkScrollDepth(): void {
    const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollDepth = window.scrollY / scrollHeight;

    if (scrollDepth >= scrollThreshold && !scrollToastShown && scrollToast) {
      scrollToast.hidden = false;
      sessionStorage.setItem('scrollToastShown', 'true');
      scrollToastShown = 'true';
      window.removeEventListener('scroll', checkScrollDepth);
    }
  }

  window.addEventListener('scroll', checkScrollDepth, { passive: true });

  const closeButtons = scrollToast.querySelectorAll<HTMLButtonElement>('[data-scroll-toast-close]');
  closeButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      scrollToast.hidden = true;
    });
  });
}
